export function shouldClearAccountQueries(
  previousUserID: string | null,
  currentUserID: string | null
) {
  return previousUserID !== null && previousUserID !== currentUserID;
}
